import React, { useEffect } from 'react';
import infoImage from '../../../assets/images/vectorsmartobject-4.png';
import './Info.scss';
import { useSelector } from 'react-redux';
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from 'react-router-dom';
export const Info = (props) =>{
    const  lang  = useSelector(state => state.locale.lang);

    useEffect(() => {
        AOS.init();
    }, [])

    return(
        <div className='about'>
            <div className="container">
                <div className="row infoSection mt-5 pt-5 justify-content-between align-items-center  ">
                    <div className="col-xl-5 mt-3 circle-image px-3" >
                      <img src={infoImage}  alt="info"/>
                    </div>
                    <div className="col-xl-7 mt-5" data-aos="fade-up" data-aos-duration="3000">
                       {lang === 'en' && 
                        <div >
                            <h2 className="header_text bold_font mx-auto mt-md-5">{props.content.title_en}</h2>
                            <p className="main_content medium_font my-5">{props.content.description_en}</p>
                            <Link to="/registration">
                              <button className='text-white btn-primary semi_bold_font px-4 py-3 ml-auto d-block mt-3'>
                                  TRY FOR FREE
                              </button>
                            </Link>
                        </div>
                       }
                       {lang === 'ar' && 
                        <>
                            <h2 className="header_text mb-5 bold_font">{props.content.title_ar}</h2>
                            <p className="main_content medium_font my-5">{props.content.description_ar}</p>
                            <Link to="/registration">
                              <button className='text-white btn-primary medium_font px-5 py-3 mr-xl-auto d-block mt-4 '>
                              تجربة مجانية
                              </button>
                            </Link>
                        </>
                       }
                    </div>
                </div>
            </div>
        </div>
    )
}
